import { apiClient } from "lib/apiClient";
import { IMarketAreaSettings } from "features/MarketAreas/types";

export const getMarketAreaSettings = async (): Promise<IMarketAreaSettings> => {
  const response = await apiClient.get<IMarketAreaSettings>(
    "/admin/market-areas/settings"
  );

  return response.data;
};
